import { Injectable } from "@angular/core";
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot, UrlTree } from "@angular/router";
import { Observable } from "rxjs";
import { AppConstants } from "../constants/app.contants";
import { UserService } from "../services/user.service";

@Injectable({
    providedIn: 'root'
})
export class GuestGuard implements CanActivate {
    //#region properties
    //#endregion

    //#region ctor
    /**
     * Guard that prevents authenticated users from accessing guest-only pages (like login)
     * Redirects authenticated users to the home page
     */
    constructor(private _userService: UserService, private _router: Router) {}
    //#endregion

    //#region setters
    //#endregion

    //#region getters
    //#endregion

    //#region private actions
    //#endregion

    //#region public actions
    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean | UrlTree | Observable<boolean | UrlTree> | Promise<boolean | UrlTree> {
        // Initialize user from localStorage
        this._userService.initializeFromLocalStorage();
        
        // If user is authenticated, redirect to home
        if (this._userService.isUserAuthenticated) {
            this._router.navigate([AppConstants.ROUTES.HOME]);
            return false;
        } else {
            // Allow access to login page if not authenticated
            return true;
        }
    }
    //#endregion
}
